import * as tslib_1 from "tslib";
import { ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { FileHandle } from 'src/app/modules/backend/photo-upload/photo-upload.component';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
export var PhotoPosition;
(function (PhotoPosition) {
    PhotoPosition[PhotoPosition["top"] = 1] = "top";
    PhotoPosition[PhotoPosition["middle"] = 2] = "middle";
    PhotoPosition[PhotoPosition["bottom"] = 3] = "bottom";
})(PhotoPosition || (PhotoPosition = {}));
export class ModalGeneralInformationComponent {
    constructor(_renderer2, _bsModalService, el, partnerService) {
        this._renderer2 = _renderer2;
        this._bsModalService = _bsModalService;
        this.el = el;
        this.partnerService = partnerService;
        this._onDestroy$ = new Subject();
        this.ngoPartner = [];
        this.position = 1;
        this.uploadImageClass = 'upload-file-image';
        this.isInvildSelect = false;
        this.createNewPartner = (name) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.creatingNew = true;
            let partner = yield this.partnerService.createNgoPartner({ name: name, url: '' });
            this._ngoPartners.push(partner);
            this.creatingNew = false;
            return { ngoPartnerId: partner.ngoPartnerId, partnerName: partner.partnerName, partnerUrl: partner.url };
        });
        this.creatingNew = false;
    }
    ngOnInit() {
        this.isSaved$ = new Subject();
        if (this.isLandOwner && !this.isCreate && this.site.newLandOwnerPhoto) {
            this.filesSelected(this.site.newLandOwnerPhoto);
        }
        else if (!this.isCreate && !this.isLandOwner && this.ngoPartner.length > 0) {
            this.description = this.ngoPartner[0].description;
            this.photo = this.ngoPartner[0].photo;
            this.oldNgoPartner = this.ngoPartner;
        }
    }
    ngOnDestroy() {
        this._onDestroy$.next();
        this._onDestroy$.complete();
        this.isSaved$.complete();
        const body = document.getElementsByTagName("body")[0];
        this._renderer2.removeClass(body, "modal-open");
    }
    hideNavModal() {
        this._bsModalService.hide();
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isLandOwner) {
                if (this.isInvalidDirectives.some(value => value.isInvalid))
                    return;
                yield this.isSaved$.next(true);
                this._bsModalService.hide();
            }
            else {
                if (this.ngoPartner.length == 0) {
                    this.isInvildSelect = true;
                    const ngSelect = document.getElementsByClassName("ng-select-container")[0];
                    ngSelect.setAttribute('style', 'border-color: #D22929;');
                    return;
                }
                if (this.isInvalidDirectives.some(value => value.isInvalid))
                    return;
                this.ngoPartner[0].description = this.description;
                yield this.partnerService.updateNgoPartner(this.ngoPartner[0]);
                if (this.newNgoPhoto) {
                    var result = yield this.partnerService.updateNgoPartnerPhoto(this.newNgoPhoto, this.ngoPartner[0].ngoPartnerId);
                    this.ngoPartner[0].photo = result.data;
                }
                this.checkduplicatePartner();
                yield this.isSaved$.next(true);
                this._bsModalService.hide();
            }
        });
    }
    checkDuplicate(ngoPartnerId) {
        const anyDuplicate = this.site.partners.find(function (value) { return value.ngoPartnerId == ngoPartnerId; });
        return anyDuplicate;
    }
    checkduplicatePartner() {
        const ngoPartnerId = this.ngoPartner[0].ngoPartnerId;
        var anyDuplicate = this.checkDuplicate(ngoPartnerId);
        if (anyDuplicate && this.isCreate) {
            this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId), 1, this.ngoPartner[0]);
        }
        else if (!this.isCreate && this.oldNgoPartner[0].ngoPartnerId === ngoPartnerId) {
            this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId), 1, this.ngoPartner[0]);
        }
        else if (!this.isCreate && this.oldNgoPartner[0].ngoPartnerId != ngoPartnerId) {
            const anyDuplicateOldPartner = this.checkDuplicate(this.oldNgoPartner[0].ngoPartnerId);
            if (anyDuplicateOldPartner) {
                var anyDuplicateInPartner = this.checkDuplicate(ngoPartnerId);
                if (anyDuplicateInPartner) {
                    this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === this.oldNgoPartner[0].ngoPartnerId), 1);
                    this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === ngoPartnerId), 1, this.ngoPartner[0]);
                }
                else {
                    this.site.partners.splice(this.site.partners.findIndex(e => e.ngoPartnerId === this.oldNgoPartner[0].ngoPartnerId), 1, this.ngoPartner[0]);
                }
            }
        }
        else {
            this.site.partners.push(this.ngoPartner[0]);
        }
    }
    onPhotoSelected(photo) {
        if (this.isLandOwner) {
            this.site.newLandOwnerPhoto = photo;
            this.site.photoPosition = PhotoPosition.top;
            1;
            this.site.landOwnerPhoto = null;
        }
        else {
            this.newNgoPhoto = photo;
        }
    }
    trimAndLower(term, ngo) {
        let pattern = '^' + term.trim().toLowerCase() + '$';
        let matchingRegex = new RegExp(pattern);
        return !!ngo.partnerName.toLowerCase().match(matchingRegex);
    }
    filesSelected(fileList) {
        let file = fileList;
        const url = window.URL.createObjectURL(file);
        this.file = { file, url };
        let options = {
            pixelRatio: window.devicePixelRatio,
            downsamplingRatio: 0.5,
            orientation: true
        };
        this.position = 1;
        loadImage(file, (canvas) => {
            canvas.className = this.getUploadImageContainerClass();
            let myTag = this.el.nativeElement.querySelector(".canvas-img");
            this._renderer2.appendChild(myTag, canvas);
        }, options);
    }
    getUploadImageContainerClass(position = 1) {
        if (position == 1)
            return `${this.uploadImageClass} top`;
        else if (position == 2)
            return `${this.uploadImageClass} middle`;
        return `${this.uploadImageClass} bottom`;
    }
    onSelect(partner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (partner.length != 0) {
                const partnerData = yield this.partnerService.getById(partner[0].ngoPartnerId);
                this.photo = partnerData.photo;
                this.description = partnerData.description;
                if (partnerData.photo) {
                    this.ngoPartner[0].photo = partnerData.photo;
                }
                if (this.newNgoPhoto) {
                    this.newNgoPhoto = null;
                    const oldphoto = document.getElementsByClassName("upload-file-image")[0];
                    oldphoto.remove();
                }
                this.isInvildSelect = false;
                const ngSelect = document.getElementsByClassName("ng-select-container")[0];
                ngSelect.setAttribute('style', '');
            }
            else {
                this.photo = null;
                this.description = "";
                if (this.newNgoPhoto) {
                    this.newNgoPhoto = null;
                    const oldphoto = document.getElementsByClassName("upload-file-image")[0];
                    oldphoto.remove();
                }
            }
        });
    }
}
